import { FeberApiClient } from "./commonServices"
import { IGetOrgInfoReq, Organization } from "./type"

export const getSuperiorDeps = async (request: IGetOrgInfoReq, includeDeputy: boolean = false) => {
    try {
        let response = (await FeberApiClient.post('Organization/GetROUs', request, { params: { includeDeputy: includeDeputy } })).data
        return response.data as Organization[];
    } catch (error) {
        console.log(error);
        return undefined;
    }
}

export const getDirectDeps = async (request: IGetOrgInfoReq, includeDeputy: boolean = false) => {
    try {
        let response = (await FeberApiClient.post('Organization/getDirectManagers', request, { params: { includeDeputy: includeDeputy } })).data
        return response.data as Organization[];
    } catch (error) {
        console.log(error);
        return undefined
    }
}